// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Dk-z","tupacHeader":"Ek-z","tupacHeader2":"Fk-z","tupacMenu":"Gk-z","tupacMenu2":"Hk-z","tupacMain":"Ik-z","tupacMain2":"Jk-z"};